export type AudioMimeInfo = { mime: string; ext: string };

const MIMES = [
  'audio/webm;codecs=opus',
  'audio/ogg;codecs=opus',
  'audio/mp4;codecs=mp4a.40.2',
  'audio/webm',
  'audio/ogg',
  'audio/mp4',
] as const;

export function pickBestMime(): AudioMimeInfo {
  let mime = 'audio/webm';
  if (typeof MediaRecorder !== 'undefined') {
    const found = MIMES.find((m) => {
      try {
        return MediaRecorder.isTypeSupported(m);
      } catch {
        return false;
      }
    });
    if (found) mime = found;
  }
  return { mime, ext: extFromMime(mime) };
}

export function extFromMime(mime?: string) {
  const bare = (mime ?? '').split(';', 1)[0].trim();
  const subtype = bare.split('/')[1]?.toLowerCase() || '';
  return subtype ?? 'webm';
}

export function makeFileName(mime?: string, prefix = 'audio'): string {
  const ts = new Date().toISOString().replace(/[:.]/g, '-');
  return `${prefix}_${ts}.${extFromMime(mime)}`;
}

export function stripMimeParams(mime?: string): string {
  return (mime ?? '').split(';', 1)[0].trim();
}

export function mimeFromExt(ext: string | undefined): AudioMimeInfo {
  if (!ext) {
    return { mime: 'audio/webm', ext: 'webm' };
  }

  switch (ext) {
    case 'webm':
      return { mime: 'audio/webm', ext: 'webm' };
    case 'ogg':
      return { mime: 'audio/ogg', ext: 'ogg' };
    case 'm4a':
      return { mime: 'audio/mp4', ext: 'm4a' };
    default:
      return { mime: 'audio/webm', ext: 'webm' };
  }
}
